import React from 'react';
import './_activateUnifyCard.less';
import { UnifyLogo } from 'IMAGE';
import { Button } from 'antd';
import PropTypes from 'prop-types';

const ActivateUnifyCard = ({ activateAccess, firstLoginUnify }) => {
  const handleClick = () => {
    activateAccess('lava');
  };

  return (
    <div className='card-dashboard-unify'>
      <div className='card-dashboard-unify__content'>
        <div className='title'>
          <UnifyLogo /> <span className='title__text'>LAVA</span>
        </div>
        <div className='subtitle'>
          <span>Convenient investing in one place</span>
        </div>
        <div className='description'>Maximise your returns through smart, tailored investment strategies</div>

        {/*<div className='label'>COMING SOON...</div>*/}
        <Button htmlType='submit' type={'dashed'} size={'large'} onClick={handleClick} block>
          {firstLoginUnify ? 'Activate access' : 'Re-Login'}
        </Button>
      </div>
    </div>
  );
};

export default ActivateUnifyCard;

ActivateUnifyCard.propTypes = {
  activateAccess: PropTypes.func.isRequired,
};
